import React from 'react'
import { ButtonBookmarkIcon } from '../../../components'
import { useInternationalization } from '../../../features/i18n'
import { useViewport } from '../../../utils'
import { excerptTrimmer } from '../../../utils/excerpt-trimmer'

const MAX_TITLE_LENGTH = 90
const THUMBNAIL_HEIGHT = '120px'
const THUMBNAIL_HEIGHT_MOBILE = '76px'

const Card = ({data, short, bookmark, embed}) => {
  const {
    thumbnail,
    category,
    organization,
    title = ['', ''],
    special
  } = data
  const { translate, language } = useInternationalization()

  const checkTranslation = (stringOrObject) => {
    const target = stringOrObject
    return typeof target === 'string' ? target
      : target && target[language.name] ? target[language.name]
      : JSON.stringify(target)
  }

  const titleRendered = checkTranslation(title)
  const titleTrimmed = excerptTrimmer(titleRendered, MAX_TITLE_LENGTH)
  const categoryRendered = category && category[language.name] ? category[language.name] : '-'
  const { isMobile } = useViewport()

  return (
    <div
      className="bg-white rounded p-3 lg:p-5 h-full"
      style={{boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'}}
      title={titleRendered}
    >
      <div
        className="w-full bg-no-repeat bg-cover bg-center mb-3 lg:mb-4 rounded p-2"
        style={{backgroundImage: `url('${thumbnail}')`, height: isMobile ? THUMBNAIL_HEIGHT_MOBILE : THUMBNAIL_HEIGHT}}
      >
        {
          bookmark &&
          <ButtonBookmarkIcon className="ml-auto bg-white"/>
        }
      </div>
      <p className="text-gray-500 text-xs mb-2">{categoryRendered} {organization && <span>/<br />{organization}</span>}</p>
      {
        special &&
        <div className="rounded px-1 text-white text-xs mb-2 inline-block" style={{background: '#FF5448'}}>
          {translate('RESOURCE', 'special')}
        </div>
      }
      <h3 className="lg:text-lg font-bold lg:mb-2 font-primary break-words">
        {titleTrimmed}
      </h3>
    </div>
  )
}

export { Card }
